export const promiseCache = (fn) => {
    const NO_RESULT = {}; 
    let res = NO_RESULT;
    return function () { 
        if(res === NO_RESULT) 
        {
            return (res = fn.apply(this, arguments));
        }
        return res;
    };
  }